import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdjustmentsApprovalComponent } from './adjustments-approval/adjustments-approval.component';
import { ApprovalFlowComponent } from './approval-flow/approval-flow.component';
import { ManageApprovalComponent } from './manage-approval/manage-approval.component';
import { TicketApprovalsComponent } from './ticket-approvals/ticket-approvals.component';
import { TicketProcessComponent } from './ticket-process/ticket-process.component';
import { EmployeeDocumentComponent } from './employee-document/employee-document.component';
import { TicketPendingComponent } from './ticket-pending/ticket-pending.component';
import { ApprovalsComponent } from './approvals/approvals.component';
import { AuthGaurdService } from '../service/auth-gaurd.service';

const routes: Routes = [
  {path:'approval-flow', component:ApprovalFlowComponent, canActivate: [AuthGaurdService], data: { roles: ['ADMIN', 'Admin'] } },
  {path:'manage-approval', component:ManageApprovalComponent, canActivate: [AuthGaurdService], data: { roles: ['ADMIN', 'Admin'] } },
  {path:'adjustments-approval', component:AdjustmentsApprovalComponent, canActivate: [AuthGaurdService], data: { roles: ['ADMIN', 'Admin'] } },
  {path:'ticket-approvals', component:TicketApprovalsComponent,  canActivate: [AuthGaurdService],data: { roles: ['ADMIN', 'Admin'] } },
  {path:'ticket-process', component:TicketProcessComponent, canActivate: [AuthGaurdService], data: { roles: ['ADMIN', 'Admin'] } },
  {path:'ticket-pending', component:TicketPendingComponent, canActivate: [AuthGaurdService], data: { roles: ['ADMIN', 'Admin'] } },
  {path:'emp-doc', component:EmployeeDocumentComponent, canActivate: [AuthGaurdService], data: { roles: ['ADMIN', 'Admin', 'Sales Representative'] } },
  {path:'approvals', component:ApprovalsComponent, canActivate: [AuthGaurdService], data: { roles: ['ADMIN', 'Admin', 'Supervisor', 'Sales Representative', 'Sales Channel Admin'] } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminPortalRoutingModule { }
